import React, {useEffect, useState} from 'react';
import {
  Grid, 
  TextField, Stepper, Step, IconButton, Tooltip, InputAdornment,
  Paper, Typography, Autocomplete, Box,
  Button, MenuItem, InputLabel,Select, FormControl, 
} from '@mui/material';


import { useSelector,useDispatch } from 'react-redux';
import {  
  selectAllUsers,
  selectUserIds,
  selectAllHosts,
  selectUserById,
  fetchAllUsers,
  createUser,
  updateUser,
  deleteUser,
  selectUserIdsByFilter,
  selectAllUsernames,
}  from '../../store/userSlice'

import DeleteIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/AutoFixHigh';


import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';

import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Avatar from '@mui/material/Avatar';


import { format, set } from 'date-fns';

import {useAppAuthContext} from '../../utils/AppAuthContext'

import {usePlayContext} from '../../utils/PlayContext';

import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';


import ConfirmDialog from '../../components/ConfirmDialog';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';

import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import { KeyTwoTone } from '@mui/icons-material';



const UserDSialog = (props) => {
  const {
    op, setOp, setStatus, setErrorMessage,
    nid, setNid,
   openSnackToast
  }=usePlayContext()

  const dispatch = useDispatch()
  const [reason, setReason] = useState(nid?.reason)
  const [reasonError, setReasonError] = useState('')

  const [userName, setUsername] = useState('')
  const [userNameError, setUsernameError] = useState('')

  const [fullName, setFullname] = useState('')
  const [fullNameError, setFullnameError] = useState('')
  const [email, setEmail] = React.useState('')
  const [emailError, setEmailError] = React.useState('')
  const [company, setCompany] = React.useState('');
  const [companyError, setCompanyError] = React.useState('');
  const [phone, setPhone] = React.useState('')
  const [phoneError, setPhoneError] = React.useState('');


  const allUsernames = useSelector(selectAllUsernames)

  let myttile = '', mylabel='', mysize='lg'

  if (op==='add'){
    myttile = mylabel = 'Create'
  } 
  else    if (op==='edit'){
    myttile = 'Edit'
    mylabel='Update'
  } 
  else if (op==='delete')
  {
    myttile = mylabel = 'Delete'

  }

    const doDelete= async(id)=>
    {
        setStatus('loading')
        try
        {
            let xx = dispatch(deleteUser(id)).unwrap();
            setStatus('idle')
        }
        catch (ex)
        {
            console.error(ex)
            setErrorMessage("Error during deletion")
            setStatus('error')
        }

        setOp('')
        setNid(null)

    }
  
    const doCommit=async()=>
    {

      if ('delete'==op)
      {
          await doDelete(nid.id);     
          return;
      }

      //alert(1111)
      if (!Boolean(reason) || !Boolean(reason.trim()))
      {
          setReasonError('Purpose for Visit cannot be empty')
          return;
      }
      
      
      
      let reason1=reason.toLowerCase()

      let xx = allUsernames.find(x=> x.reason.toLowerCase()===reason1)
            

      if (xx)
      {
          if (op==='add')
          {
              setReasonError('Purpose for Visit already exists')
              return;
          }
          else
          {
              if (xx.id!==nid.ip)
              {
                setReasonError('Purpose for Visit already exists')
                return;
              }
  
          }
      }

      
        setStatus('idle')
        try
        {

          if (op==='add')
          {
              await dispatch(createUser({reason})).unwrap();
          }
          else
          {
            await dispatch(updateUser(
              {
                reason,
                id:nid.id
              })
              
              ).unwrap();
          }
          setStatus('idle')

          
        }
        catch (ex)
        {
            console.error(ex)
            setErrorMessage("Error during reason "+ (op==='add'? 'creation':'update'));
            setStatus('error')
        }

        setOp('')
        setNid(null)

    }
  return (
    <Dialog 
        open={Boolean(op)}
        
        maxWidth={mysize}
        onClose={e => setOp('')}>
      <DialogTitle sx={{}}><small>{myttile}&nbsp;Purpose for Visit</small></DialogTitle>
      <DialogContent>
        <Box sx={{p:1, mx:0, border:0, borderColor:'#999999', borderRadius:3, maxWidth:900, minWidth:600}}>

          {
            op==='delete' &&
              <Typography variant='h6' textAlign='center' sx={{color:'primary.main'}}>
                Are you sure to delete the item {nid.id}?
                </Typography>
          }
          {
            (op==='edit' || op==='add') &&
              <TextField 
                size='small'
                required
                fullWidth
                error={Boolean(reasonError)}
                value={reason}
                id="id_remarks" label="Purpose for Visit" type="text" 
                onChange = { e=>setReason(e.target.value)}
                inputProps={{ maxLength: 100,  }}
                helperText={ reasonError}/>

          }
          </Box>
      </DialogContent>
         
      <DialogActions sx={{m:0,pb:2}}>
        <Box sx={{display:'flex', justifyContent:'space-around', width:'88%'}}>
            <Button variant="outlined"autoFocus size='small' color='primary'
                onClick={doCommit}
                disabled={!Boolean(reason) || !Boolean(reason.trim())}
                >
                {mylabel}
            </Button>
            <Button
                onClick={e=>{setNid(null); setOp("")}}
                color='success' 
                size='small'>
              Cancel
            </Button>
        </Box>
      </DialogActions>
     </Dialog>
  );
};


const UserTableHeader=()=>{

  return (
        <TableHead>
                <TableRow sx={{bgcolor:'#98DDFF'}}>
                  
                  <TableCell align="center" 
                        style={{border: '1px solid LightGray', fontWeight: 600}}>USER ID</TableCell>
                  <TableCell align="center" 
                        
                        style={{border: '1px solid LightGray', fontWeight: 600}}>ROLE</TableCell>
                    <TableCell align="center" 
                        
                        style={{border: '1px solid LightGray', fontWeight: 600}}>FULL NAME</TableCell>
                    <TableCell align="center" 
                        
                        style={{border: '1px solid LightGray', fontWeight: 600}}>EMAIL</TableCell>
                    <TableCell align="center" 
                        
                        style={{border: '1px solid LightGray', fontWeight: 600}}>PHONE</TableCell>
                    <TableCell align="center" 
                        
                        style={{border: '1px solid LightGray', fontWeight: 600}}>Organization</TableCell>
                  
                    <TableCell align="center" style={{border: '1px solid LightGray', fontWeight: 600}}>ACTIONS</TableCell>
                    
                  </TableRow>
      </TableHead>

  )
}

const UserTableRow=({id, index})=>
{
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const {
      op, setOp,
      nid, setNid,
     openSnackToast
    }=usePlayContext()
    const row = useSelector(  selectUserById(id))


    const deteteRow= ()=>{
        if (id && row)
        {
          setNid(row)
          setOp('delete')
        }
    }
    const editRow =()=>{
      if (id && row)
      {
        setNid(row)
        setOp('edit')
  
      }

    }


    return(
      <TableRow>
        <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap', }}>
            {row.userName}
        </TableCell>
        <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap', }}>
            {row.roles}
        </TableCell>
        <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap', }}>
            {row.fullName}
        </TableCell>
        <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap', }}>
            {row.email}
        </TableCell>
        <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap', }}>
            {row.phone}
        </TableCell>
        <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap', }}>
            {row.company}
        </TableCell>
        <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap'}}>
            <Box sx={{display:'flex', justifyContent:'space-around', flexDirection:'row', m:0, p:0}} >

            <Tooltip title='Edit user'>
                <IconButton size='small' color='primary' 
                    disabled
                    onClick={editRow}
                    >
                    <EditIcon size='small'/>
                </IconButton>
              </Tooltip>
              <Tooltip title='Delete user'>
                    <IconButton size='small' color='primary'
                      disabled
                      onClick={deteteRow}
                    ><DeleteIcon size='small'/>
                    </IconButton>
              </Tooltip>
            </Box>
        </TableCell>
  </TableRow>

    )


}



const ReasonPage = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch()




    const {userInfo, managedHosts} = useAppAuthContext()
  
    const {
      op, setOp,
      nid, setNid,
      status, setStatus, setAppTitle, 
      setErrorMessage,  setErrorTitle,
      setTenantLogo, openSnackToast
    }=usePlayContext()


    const [keyword, setKeyword]=useState('');
  
    const allReasonIds = useSelector(state=>selectUserIdsByFilter(state, keyword))
  
    const addReason = ()=>{
      setOp('add')
          
      setNid(null)
        //alert(123)

    } 

    useEffect(() => {
      setAppTitle(  ['Administration','Users', ])
      setErrorMessage('')
      setErrorTitle('')

      setOp('')
      setNid(null)
      
      return () => {

      }

  }, [])

  
  

  return (
    <Box sx={{p:1}}>
        <Card sx={{width:'100%',  pt:2, mb:1, pb:0}} raised>
            
        <CardContent sx={{my:0, py:1}}>
        <Grid
          container 
          spacing={1}
          direction={'row'}
          columns={12}
        >
       
             <Grid item xs={12} sm={6}  md={4} >
              <Autocomplete 
                fullWidth
                size='small'
                freeSolo
                selectOnFocus
                handleHomeEndKeys
                //disableClearable
                id="id_reason" 
                value={keyword}
                options={[]} 
                renderInput={(params) => 
                    <TextField {...params} 
                      onChange = { e=>{setKeyword(e.target.value);}}
                      label="Search Key Word"  
                      />}
                />
              </Grid>
            <Grid item xs={12} sm={6} md={8} sx={{  }}>
              <Box sx={{mt:1,display:'flex', width:'100%', justifyContent: 'space-between'}}>

                  <Button variant="outlined"  color='info'  
                    onClick={e=>setKeyword('')}
                  > Reset</Button>

                  <Button variant="outlined"  color='primary'
                    disabled  
                    onClick={addReason}
                  > Add</Button>
              </Box>
          </Grid>                          
        </Grid>

        </CardContent>
        </Card>
          <TableContainer component={Paper} >
            <Table  size='small' >
              <UserTableHeader/>
                <TableBody>
                  { allReasonIds && allReasonIds.length>0 &&
                      allReasonIds.map((id, i)=>

                        <UserTableRow key={id} id={id}/> 
                      )
                  }
              </TableBody>
            </Table>
        </TableContainer>
        
        {Boolean(op)&& 
        <UserDSialog />
        }
      </Box>
  );
};


export default ReasonPage;
